import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";

BigInt.prototype.toJSON = function () {
  return this.toString();
};
declare global {
  interface BigInt {
    toJSON(): string;
  }
}
const queryClient = new QueryClient();
const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element #root not found");
}
ReactDOM.createRoot(rootElement).render(
  <QueryClientProvider client={queryClient}>
    {/* Public portfolio and HTTP contact form do not use Internet Identity. */}
    <App />
  </QueryClientProvider>,
);
